import React from 'react';
import PropTypes from 'prop-types';

import {
  Accordion as MuiAccordion,
  AccordionSummary as MuiAccordionSummary,
  AccordionDetails as MuiAccordionDetails
} from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';

import CriteriaManagementSection from './CriteriaManagementSection';
import { Icon, Translate } from '@hydra/common/components';

import mapModuleToIcon from '@hydra/utils/mapModuleToIcon';

const useStyles = makeStyles(theme => ({
  type: {
    marginLeft: theme.spacing(1),
    fontSize: theme.typography.fontSizeLarge,
    fontWeight: theme.typography.fontWeightNormal

  }
}));

const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    borderRight: 'none',
    borderLeft: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&:before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 'auto'
    }
  },
  expanded: {}
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56
    }
  },
  content: {
    '&$expanded': {
      margin: '12px 0'
    }
  },
  expanded: {}
})(MuiAccordionSummary);

const AccordionDetails = withStyles(theme => ({
  root: {
    flexDirection: 'column',
    padding: theme.spacing(0, 3)
  }
}))(MuiAccordionDetails);

export const ModulePanel = ({
  template,
  module,
  editing,
  editingValue,
  setEditingValue,
  setEditingField,
  resetEditing,
  saveFormField
}) => {
  const classes = useStyles();
  return (
    <Accordion id={`module-panel-${module.type}`}>
      <AccordionSummary
        expandIcon={<Icon size='lg' type='chevron-down' fill='grey' />}
      >
        <Icon type={mapModuleToIcon(module.type)} />
        <Translate content={module.type} className={classes.type} />
      </AccordionSummary>
      <AccordionDetails>
        <CriteriaManagementSection
          template={template}
          section={module}
          editing={editing}
          editingValue={editingValue}
          setEditingValue={setEditingValue}
          setEditingField={setEditingField}
          resetEditing={resetEditing}
          saveFormField={saveFormField}
        />
      </AccordionDetails>
    </Accordion>
  );
};

ModulePanel.propTypes = {
  template: PropTypes.shape({
    id: PropTypes.string
  }),
  module: PropTypes.shape({
    type: PropTypes.string
  })
};

export default React.memo(ModulePanel);
